import { render, staticRenderFns } from "./UnsupportedAgent.vue?vue&type=template&id=79edc9d2&scoped=true&lang=pug"
import script from "./UnsupportedAgent.vue?vue&type=script&lang=ts"
export * from "./UnsupportedAgent.vue?vue&type=script&lang=ts"
import style0 from "./UnsupportedAgent.vue?vue&type=style&index=0&id=79edc9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79edc9d2",
  null
  
)

export default component.exports